import React, { useEffect, useState } from "react";
import { getContractsById } from "../../../slices/thunk";
import { Col, Container, Row, Spinner, Button, Alert } from "react-bootstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ContractList from "./contract-list";
import { jwtDecode } from "jwt-decode";
import Tutorial from "./Tutorial";
import {
  acceptContractTerms,
  getSubscribedUser,
  handleStripePackage,
  cancelSubscription,
} from "../../../slices/thunk";
import { useTranslation } from "react-i18next";
import CreateChangeOrderModal from "./tabs/createChangeOrder";
import NewEditor from "ractTable";
import { Card } from "components/ui/card";
import { DollarSign } from "lucide-react";
import { selectUserDetails } from "slices/userProfile/reducer";
import { NewContractList } from "./contract-list/newContractList";
import { mockContracts } from "pages/data/mockContracts";
import { SubcontractAgreementList } from "./SubcontractAgreement";
import { hasPermission } from "Common/permissions";
import "./contract-dashboard.css";


interface CreateProjectProps {}
interface JwtPayload {
  userType: string;
}

const CreateProject: React.FC<CreateProjectProps> = () => {
  const dispatch: any = useDispatch();
  const token = localStorage.getItem("authUser");
  let decoded: any = "";
  const { t } = useTranslation(); // ✅ React knows to update

  if (token !== null) {
    decoded = jwtDecode<JwtPayload>(token);
  } else {
    console.error("Token is null");
  }
  const [loading, setLoading] = useState<boolean>(false);
const [userDetails] = useSelector(selectUserDetails)
  useEffect(() => {
    document.title = "Tradesmen Admin";
  }, []);

  const [termsAccepted, setTermsAccepted] = useState(false);
  const [paymentPageShow,setPaymentPageShow]=useState(false)



  useEffect(() => {
    setLoading(true);
    dispatch(getSubscribedUser()).then((resp: any) => {
      if (decoded.userType === "contractor") {
        if (resp && resp.subscription.status === "active") {
          setTermsAccepted(true);
        } else {
          setTermsAccepted(false);
        }
      } else {
        setTermsAccepted(true);
      }
      setLoading(false);
    });
  }, [dispatch]);

  const userSubscribed = useSelector(
    (state: any) => state.UserProfile.subscribedData
  );
  const handleSubmitStatus = () => {
    dispatch(getSubscribedUser()).then((resp: any) => {
      if (decoded.userType === "contractor") {
        if (resp && resp.subscription.status === "active") {
          setTermsAccepted(true);
        } else {
          setTermsAccepted(false);
        }
      } else {
        setTermsAccepted(true);
      }
      setLoading(false);
    });
  };
const navigation = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams();
  const canViewSubcontracts =
    decoded.userType === "admin" ||
    decoded.userType === "subcontractor" ||
    (decoded.userType === "contractor" &&
      hasPermission(["MANAGE_SUBCONTRAC", "MANAGE_SUBCONTRACT", "VIEW_SUBCONTRACT"]));
  const requestedView = searchParams.get("view");
  const activeView = requestedView === "subcontracts" && canViewSubcontracts
    ? "subcontracts"
    : "contracts";

  const switchDashboardView = (view: "contracts" | "subcontracts") => {
    const nextParams = new URLSearchParams(searchParams);
    if (view === "contracts") {
      nextParams.delete("view");
    } else {
      nextParams.set("view", view);
    }
    setSearchParams(nextParams);
  };

  return (
    <React.Fragment>
      <div className="page-content contract-dashboard-page">
        <Container fluid>
          {/* {termsAccepted &&
            (decoded.userType === "contractor" ||
              decoded.userType === "testContractor") &&
            (userSubscribed && userSubscribed.remainingDays === 0 ? (
              <Alert variant="success">
                <i className="bx bx-spreadsheet align-baseline me-1"></i>
             {t("Your Subscription is live. Thank you for choosing The Tradesmen's Collective.")}
               
                <Link to="/contract-tutorial-and-plans">
                  {t("Know More or Cancel Plan")}
                </Link>
              </Alert>
            ) : (
              <Alert variant="danger">
                <i className="bx bx-spreadsheet align-baseline me-1"></i>
                {t("You have a complimentary")} <b> {t("30-day trial period")}</b> {t("to experience this contract service at no cost. Only")}
                <b>
                  {userSubscribed && userSubscribed.remainingDays} days left
                </b>
                .{" "}
                <Link to="/contract-tutorial-and-plans">
                 {t("Know More or Cancel Plan")} 
                </Link>
              </Alert>
            ))} */}
          {canViewSubcontracts ? (
            <div className="contract-dashboard-switcher" role="tablist" aria-label={t("Contract views")}>
                <button
                  type="button"
                  onClick={() => switchDashboardView("contracts")}
                  className={activeView === "contracts" ? "is-active" : ""}
                  role="tab"
                  aria-selected={activeView === "contracts"}
                >
                  {t("Contracts")}
                </button>
                <button
                  type="button"
                  onClick={() => switchDashboardView("subcontracts")}
                  className={activeView === "subcontracts" ? "is-active" : ""}
                  role="tab"
                  aria-selected={activeView === "subcontracts"}
                >
                  {t("Subcontracts")}
                </button>
            </div>
          ) : null}
          {/* {userDetails?.user_type === "homeowner"||userDetails?.user_type === "contractor"  ?userDetails?.kyc_verified !==1 ?    <div className="tailwind-prefix">
        <Card className="p-3 mb-6 bg-amber-50 border-amber-200">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                <DollarSign className="w-4 h-4 text-amber-600" />
              </div>
              <div className="flex-1">
                <div className="mb-1 text-[14px]" >Complete KYC Verification</div>
                <div className="text-[12px] text-slate-600 mb-2">
                  You need to complete KYC verification before you can {`${userDetails?.user_type ==="homeowner"?"make payments for contractors":"Receive payments"}`}.
                </div>
                <Button 
                  size="sm" 
                  onClick={()=>{
                    navigation("/kyc-status-page")
                  }}
                  className="bg-amber-600 border-0 p-2 rounded-[8px] hover:bg-amber-700"
                >
                  Complete Verification
                </Button>
              </div>
            </div>
          </Card>
        </div>:null:null} */}
     
         
          <Row>
            <Col xl={12}>
              {activeView === "subcontracts" ? (
                <SubcontractAgreementList />
              ) : loading ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ minHeight: "200px" }}
                >
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>
              ) : !termsAccepted?!paymentPageShow?
       
                <ContractList setPaymentPageShow={setPaymentPageShow} termsAccepted={termsAccepted} handleStatus={handleSubmitStatus} /> :<Tutorial setPaymentPageShow={setPaymentPageShow} handleStatus={handleSubmitStatus} />:<ContractList setPaymentPageShow={setPaymentPageShow} termsAccepted={termsAccepted} handleStatus={handleSubmitStatus} /> 




              }
            </Col>
          </Row>
        </Container>
      
      </div>
    </React.Fragment>
  );
};

export default CreateProject;
